import './App.css';
import letterk from './assets/k-key.png';
import letterp from './assets/p-key.png';
import letterc from './assets/c-key.png';
import esckey from './assets/esc-key.png';
import { useNavigate, createBrowserRouter, RouterProvider } from "react-router-dom";
import React, { useEffect } from 'react';
import { type } from '@testing-library/user-event/dist/type';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main/>
  },
  {
    path: "/knowledge",
    element: <Knowledge/>
  },
  {
    path: '/projects',
    element: <Projects/>
  },
  {
    path: '/contact',
    element: <Contact/>
  }
])

function App() {
  return (
    <React.StrictMode><RouterProvider router={router}/></React.StrictMode>
  )
}

function Main() {
  const navigate = useNavigate()
  useEffect(() =>{
    function handleKeyDown(event) {
      switch (event.key) {
        case 'k':
          document.getElementById('k').classList.add('keydown')
          break
        case 'p':
          document.getElementById('p').classList.add('keydown')
          break
        case 'c':
          document.getElementById('c').classList.add('keydown')
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    async function handleNavLarge(event) {
      switch (event.key) {
        case 'k':
          document.getElementById('k').classList.remove('keydown')
          if (!document.startViewTransition) {
            navigate('/knowledge')
          } else {
            await document.startViewTransition(async () => {return await navigate('/knowledge')})
          }
          document.removeEventListener('keyup', handleNavLarge)
          document.removeEventListener('keydown', handleKeyDown)
          break
        case 'p':
          document.getElementById('p').classList.remove('keydown')
          if (!document.startViewTransition) {
            navigate('/projects')
          } else {
            await document.startViewTransition(async () => {return await navigate('/projects')})
          }
          document.removeEventListener('keyup', handleNavLarge)
          document.removeEventListener('keydown', handleKeyDown)
          break
        case 'c':
          document.getElementById('c').classList.remove('keydown')
          if (!document.startViewTransition) {
            navigate('/contact')
          } else {
            await document.startViewTransition(async () => {return await navigate('/contact')})
          }
          document.removeEventListener('keyup', handleNavLarge)
          document.removeEventListener('keydown', handleKeyDown)
          break
      }
    }
    document.addEventListener('keyup', handleNavLarge)

  }, [])
  return (
    <div className="App">
      <header className="App-header">
        <h1>paytondev</h1>
        <hr style={{width: 500}}/>
        <h2 id='opaque'>👋Hi, I'm paytondev</h2>
        <p id='opaque'>You can use your keyboard to navigate this page, take a look at the key below!</p>
        <h6 id='opaque'>If on mobile, you can just tap!</h6>
        <div id='nav-buttons'>
          <div id='knowledge' className='key-container' onClick={()=>{document.dispatchEvent(new KeyboardEvent(type='keyup', {key:'k'}))}}>
            <img className='key' id='k' src={letterk}/>
            <p className='bold'>Knowledge</p>
          </div>
          <div id='projects' className='key-container' onClick={()=>{document.dispatchEvent(new KeyboardEvent(type='keyup', {key:'p'}))}}>
            <img className='key' id='p' src={letterp}/>
            <p className='bold'>Projects</p>
          </div>
          <div id='contact' className='key-container' onClick={()=>{document.dispatchEvent(new KeyboardEvent(type='keyup', {key:'c'}))}}>
            <img className='key' id='c' src={letterc}/>
            <p className='bold'>Contact</p>
          </div>
        </div>
        <p id='disclaimer'>*note - to get the most out of this page, please enable the <a href='https://developer.chrome.com/docs/web-platform/view-transitions/'>View Transitions API</a> in your browser's experimental settings</p>
      </header>
    </div>
  );
}

function Knowledge() {
  const navigate = useNavigate()
  useEffect(() => {
    function handleEscDown(event) {
      switch (event.key) {
        case 'Escape':
          document.getElementById('esc').classList.add('keydown')
          break
      }
    }
    async function handleNav(event) {
      switch (event.key) {
        case 'Escape':
          document.getElementById('esc').classList.remove('keydown')
          if (!document.startViewTransition) {
            navigate('/')
          } else {
            document.documentElement.classList.add('back-animation')
            const transition = await document.startViewTransition(async () =>  await navigate('/'))
            setTimeout(() => {
              document.documentElement.classList.remove("back-animation")
            }, 300)
          }
          //remove event listeners (necessary for stuff)
          document.removeEventListener('keyup', handleNav)
          document.removeEventListener('keydown', handleEscDown)
          break
      }
    }
    document.addEventListener('keydown', handleEscDown)
    document.addEventListener('keyup', handleNav)
    
  }, [])
  return (
  <div className='App'>
    <header className='App-header'>
    <div id='esc' className='key-container' onClick={()=>{document.dispatchEvent(new KeyboardEvent(type='keyup', {key:'Escape'}))}}>
          <img className='key' id='esc' src={esckey}/>
          <p className='bold'>Back</p>
        </div>
      <h1>Knowledge</h1>
      <hr style={{width: 500}}/>
      <p>Here is a comprehensive list of literally everything I know (development-wise):</p>
      <div id='point-list'>
        <h2 className='point-header'>Web Development</h2>
        <ul>
          <li>Plain HTML, CSS, JS</li>
          <li>React (fun fact!: this website was made in react! woohoo!)</li>
          <li>Vue.JS</li>
          <li>Flutter (yes: flutter does have a web version!)</li>
        </ul>
        <h2 className='point-header'>Mobile Development</h2>
        <ul>
          <li>Swift & SwiftUI</li>
          <li>Flutter</li>
          <li>React Native</li>
          <li>Jetpack Compose</li>
        </ul>
        <h2 className='point-header'>Backend Development</h2>
        <ul>
          <li>Node.JS</li>
          <li>Python</li>
        </ul>
        <h2 className='point-header'>Honorable Mentions</h2>
        <p>Here are some things that I know which I can't really fit into a major category:</p>
        <h3>Database</h3>
        <ul>
          <li>Firebase</li>
          <li>Pocketbase (basically self-hosted Firebase)</li>
          <li>Supabase (open-source Firebase)</li>
          <li>AWS</li>
        </ul>
        <h3>Game Development</h3>
        <ul>
          <li>Unity. That's it.</li>
        </ul>
      </div>
    </header>
  </div>
  )
}

function Projects() {
  const navigate = useNavigate()
  
  useEffect(() => {
    function handleEscDown(event) {
      switch (event.key) {
        case 'Escape':
          document.getElementById('esc').classList.add('keydown')
          break
      }
    }
    async function handleNav(event) {
      switch (event.key) {
        case 'Escape':
          document.getElementById('esc').classList.remove('keydown')
          if (!document.startViewTransition) {
            navigate('/')
          } else {
            document.documentElement.classList.add('back-animation')
            const transition = await document.startViewTransition(async () =>  await navigate('/'))
            setTimeout(() => {
              document.documentElement.classList.remove("back-animation")
            }, 300)
          }
          //remove event listeners (necessary for stuff)
          document.removeEventListener('keyup', handleNav)
          document.removeEventListener('keydown', handleEscDown)
          break
      }
    }
    document.addEventListener('keydown', handleEscDown)
     document.addEventListener('keyup', handleNav)
    
  }, [])
  return (
    <div className='App'>
    <header className='App-header'>
    <div id='esc' className='key-container' onClick={()=>{document.dispatchEvent(new KeyboardEvent(type='keyup', {key:'Escape'}))}}>
          <img className='key' id='esc' src={esckey}/>
          <p className='bold'>Back</p>
        </div>
      <h1>Projects</h1>
      <hr style={{width:500}}/>
      <p>As a jobless developer, I like to partake in some projects sometimes. Here is a current list of all projects which I have worked on/am currently working on:</p>
      <div id='point-list'>
        <h2 className='point-header'>JustOne/unoweb_flutter</h2>
        <div id='bordered-div'>
          <p>JustOne is a project that came about from my own occasional, uncaught inefficiencies. JustOne is an Uno clone, built with Flutter. I wish I could say that I built it to familiarize myself with the framework, or that I built it just for fun (kinda true), but none of those are true.</p>
          <p>The unoweb_flutter name (changed to JustOne for legal reasons) came from a previous project of mine: unoweb.<br/>Unoweb was (you guessed it) an Uno clone. I promise it's different to Unoweb_flutter, the main reason being that this was writtin in plain HTML. No framework. And it worked (sorta)! The base gameplay was implemented, but there were a number of missing features (primarily special cards (wild, skip, draw)), and I tried to implement them. Just one issue:<br/>Rendering.<br/>See, to render this abhorrent mess with plain HTML, I had to create this huge, massive, unreadable <a href='https://github.com/paytontech/uno-web/blob/e39449bf8e99669ed56fdbed7b140b78000dfc92/main.js#L144'>render function. </a>It doesn't look at bad on first glance, but it was terrible to work with and didn't scale well to any new features at all. So, like the developer I am, I gave up. I set out to recreate the entire thing in Flutter, and it was a breeze. Just insanely easy. I even got online multiplayer working, something which undoubtedly would've been <b>impossible</b> with the state of the original unoweb. JustOne has taught me the ins and outs of Flutter, and it is a truly incredible framework. Insanely easy. This whole process has made me a permenant fan of it. You can even play it: <a href='https://paytontech.github.io'>https://paytontech.github.io</a> (paytondev was taken :/)</p>
        </div>
        <h2 className='point-header'>[Upcoming] Anti-trust</h2>
        <div id='bordered-div'>
          <p>(working title) Anti-trust is another "game" in the "recreate popular games in Flutter" series. A clone of Monopoly, I have literally nothing more to say about it. I haven't even started work on it, it's just been in the back of my mind for the past while and I want to start working on it. I will keep this page updated!</p>
        </div>
        <h2 className='point-header'>[No-longer Updated] SafeSign</h2>
        <div id='bordered-div'>
          <p>SafeSign was a little electron I made which served one simple function: it would email you whenever somebody signed into your computer. I enjoyed working on it, and it should still work (if you have a SendGrid API key), but due to problems with SendGrid, I haven't gotten it working in a while and eventually just lost motivation to continue work on it. I might revisit it eventually.</p>
        </div>
      </div>
    </header>
  </div>
  )
}
function Contact() {
  const navigate = useNavigate()
  
  useEffect(() => {
    function handleEscDown(event) {
      switch (event.key) {
        case 'Escape':
          document.getElementById('esc').classList.add('keydown')
          break
      }
    }
    async function handleNav(event) {
      switch (event.key) {
        case 'Escape':
          document.getElementById('esc').classList.remove('keydown')
          if (!document.startViewTransition) {
            navigate('/')
          } else {
            document.documentElement.classList.add('back-animation')
            const transition = await document.startViewTransition(async () =>  await navigate('/'))
            //super janky solution but if it works it works ig 🤷‍♂️
            setTimeout(() => {
              document.documentElement.classList.remove("back-animation")
            }, 300)
          }
          //remove event listeners (necessary for stuff)
          document.removeEventListener('keyup', handleNav)
          document.removeEventListener('keydown', handleEscDown)
          break
      }
    }
    document.addEventListener('keydown', handleEscDown)
     document.addEventListener('keyup', handleNav)
    
  }, [])
  return (
    <div className='App'>
    <header className='App-header'>
    <div id='esc' className='key-container' onClick={()=>{document.dispatchEvent(new KeyboardEvent(type='keyup', {key:'Escape'}))}}>
          <img className='key' id='esc' src={esckey}/>
          <p className='bold'>Back</p>
        </div>
      <h1>Contact</h1>
      <hr style={{width:500}}/>
      <p>As a chronically online person, I have many forms of contact and am available most hours of the day (6:00AM-11:00PM EST weekdays, and then it's really hit-or-miss on weekends)</p>
      <h2 className='point-header'>Social Media</h2>
      <ul>
        <li><a href='https://twitter.com/paytondev'>Twitter</a></li>
        <li><a href='https://youtube.com/paytondev'>YouTube</a></li>
      </ul>
      <h2 className='point-header'>Primary Contact</h2>
      <p>If you are looking to get in touch with me for business reasons, I prefer you contact me by <a href='mailto:paytondeveloper@gmail.com'>email</a>. I have email notifications on and check my inbox nearly constantly, so if you want to get in touch, don't hesitate!</p>
      <p>I also have a <a href='https://www.linkedin.com/in/payton-curry-437523262/'>LinkedIn</a></p>
    </header>
  </div>
  )
}


export default App;
